import React from 'react';
import { ReferenceLine, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';

const SeriesCompareLineChart = ({ style, series, dailyKPI, totalKPI }) => (
    <div>
        <LineChart width={style.width} height={style.height} data={series} margin={{ top: 5, right: 0, left: 0, bottom: 5 }}>
            <XAxis dataKey="title" type='category' allowDuplicatedCategory={false} label=""/>
            <YAxis dataKey="value" type='number' domain={[0, 'dataMax + 1']} allowDecimals={false} />
            
            <ReferenceLine y={dailyKPI} label="Daily" stroke="green"/>
            <ReferenceLine y={totalKPI} label="Monthly" stroke="red"/>
            <CartesianGrid strokeDasharray="3 3" />
            {/* todo: accept the label formatter as a prop */}
            <Tooltip labelFormatter={(x)=>{return 'Day #' + x;}} /> 
            <Legend />
            {
                series.map((record, index) => <Line key={index} type="monotone" dataKey="value" name={record.title} data={record.data} activeDot={{ r: 8 }} />
            )}
        </LineChart>
    </div>
);

SeriesCompareLineChart.defaultProps = {
    style: {
        width: 330,
        height: 275
    },
    data: []
};

export default SeriesCompareLineChart;



// WEBPACK FOOTER //
// ./src/components/charts/SeriesCompareLineChart.js